// Tracking : Pixel Meta + GA4 du site abonnement (mêmes IDs que www.pandacraft.com : cookies partagés
// sur .pandacraft.com, la visite continue jusqu'à la conversion dans le tunnel).
// Chaque tag n'est chargé qu'avec son ID dans config.tracking, sur un hôte de config.tracking.hosts (prod)
// ET avec le consentement Didomi (js/consent.js) ; les événements émis avant sont rejoués au chargement du tag.
// Événements : ViewContent (au chargement), ClickCTA {plan}, PlayAudio, InitiateCheckout {plan}.
// Les paramètres UTM (et fbclid/gclid) de l'URL d'arrivée sont transmis au tunnel (js/funnel.js).
//
// Balisage HTML :
//   data-track="ClickCTA" data-plan="12m"   -> envoie l'événement au clic
//   data-checkout="12m"                     -> CTA de formule, géré par js/funnel.js (InitiateCheckout)

import { onConsent } from "./ma-js-consent.js?v=9dbd173928";

const PASSTHROUGH = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "fbclid", "gclid"];
const STORE_KEY = "ma_utm";

const loaded = { meta: false, ga4: false };   // script chargé
const allowed = { meta: false, ga4: false };  // consentement en cours
const events = [];                             // événements de la visite (rejoués au chargement d'un tag)

function loadScript(src) {
  const s = document.createElement("script");
  s.async = true;
  s.src = src;
  document.head.appendChild(s);
}

function initMeta(id) {
  /* eslint-disable */
  !function (f, b, e, v, n, t, s) {
    if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
    if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
  }(window, document);
  /* eslint-enable */
  loadScript("https://connect.facebook.net/en_US/fbevents.js");
  window.fbq("init", id);
  window.fbq("track", "PageView");
  loaded.meta = true;
}

function initGa4(id, ids = {}) {
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  loadScript(`https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`);
  window.gtag("js", new Date());
  // Mêmes réglages que la balise GA4 du site (GTM-TZ7KMZ) quand le serveur de tracking est renseigné.
  const server = ids.ga4Server ? { transport_url: ids.ga4Server, server_container_url: ids.ga4Server, first_party_collection: true, cookie_expires: 31560000 } : {};
  window.gtag("config", id, server);
  loaded.ga4 = true;
}

// Événements standard Meta ; les autres passent en trackCustom.
const META_STANDARD = new Set(["ViewContent", "InitiateCheckout"]);

const send = {
  meta: (name, params) => window.fbq(META_STANDARD.has(name) ? "track" : "trackCustom", name, params),
  ga4: (name, params) => window.gtag("event", name, params)
};

export function track(name, params = {}) {
  if (events.length < 50) events.push([name, params]);
  if (allowed.meta) send.meta(name, params);
  if (allowed.ga4) send.ga4(name, params);
  if (!allowed.meta && !allowed.ga4 && location.hostname === "localhost") console.debug("[MA track]", name, params);
}

/** Applique un choix Didomi : charge le tag autorisé (une fois) et lui rejoue la visite ; un retrait coupe l'envoi. */
function applyConsent(consent, ids) {
  if (location.hostname === "localhost") console.debug("[MA consent]", consent);
  [["meta", ids.metaPixelId, initMeta], ["ga4", ids.ga4Id, initGa4]].forEach(([tag, id, init]) => {
    const was = allowed[tag];
    allowed[tag] = Boolean(id && consent[tag]);
    if (!allowed[tag] || was || loaded[tag]) return;
    init(id, ids);
    events.forEach(([name, params]) => send[tag](name, params));
  });
}

/** UTM de l'URL courante, mémorisés pour la session (navigation interne, ancres). */
export function getUtm() {
  const url = new URLSearchParams(location.search);
  const fresh = {};
  PASSTHROUGH.forEach((k) => { if (url.get(k)) fresh[k] = url.get(k); });
  try {
    if (Object.keys(fresh).length) sessionStorage.setItem(STORE_KEY, JSON.stringify(fresh));
    return Object.keys(fresh).length ? fresh : JSON.parse(sessionStorage.getItem(STORE_KEY) || "{}");
  } catch {
    return fresh;
  }
}

/** Ajoute les UTM à une URL du tunnel (sans écraser ceux déjà présents). */
export function withUtm(href) {
  if (!href) return href;
  const u = new URL(href, location.href);
  Object.entries(getUtm()).forEach(([k, v]) => { if (!u.searchParams.has(k)) u.searchParams.set(k, v); });
  return u.toString();
}

export function initTracking(config) {
  const tagsOn = (config.tracking.hosts || []).includes(location.hostname);
  onConsent(config.tracking, (consent) => applyConsent(tagsOn ? consent : { ga4: false, meta: false }, config.tracking));

  track("ViewContent", { content_name: "Mission Animalia — précommande" });

  document.addEventListener("click", (e) => {
    const el = e.target.closest("[data-track]");
    if (el) track(el.dataset.track, el.dataset.plan ? { plan: el.dataset.plan } : {});
  });
}
